/**
 * Shared contact people for Contact page (people section + form sidebar).
 * title = English, titleFi = Finnish. Logo package section is intentionally omitted.
 */
export const CONTACT_PEOPLE = [
  {
    name: 'Joonas Korgan',
    title: 'Sales, CEO',
    titleFi: 'Myynti, CEO',
    role: 'Sales, CEO',
    phone: '+358 40 568 4617',
    email: 'joonas@identio.fi',
    photoUrl: '/team/joonas-korgan.png',
    linkedinUrl: 'https://www.linkedin.com/in/joonaskorgan/',
  },
  {
    name: 'Sami Suo-Heikki',
    title: 'Recruitment, COO',
    titleFi: 'Rekrytointi, COO',
    role: 'Recruitment, COO',
    phone: '+358 40 044 9641',
    email: 'sami@identio.fi',
    photoUrl: '/contact/sami-suo-heikki.png',
    linkedinUrl: 'https://www.linkedin.com/in/samisuoheikki/',
  },
];
